import PropTypes from 'prop-types';
import React from 'react';
import Link from 'brastrap/containers/link/LinkContainer';
import Modal from './Modal';

const ModalLink = props => {
  const {
    modal,
    modalId,
    isOpen,
    url,
    alt,
    label,
    onModalOpen,
    onModalClose,
    children,
    icon,
  } = props;

  modal.actions = {
    dismiss: {
      icon: {
        icon: 'dismiss',
        label: 'Close',
        labelled: 'after',
      },
      onClick: () => onModalClose(),
    },
  };

  return (
    <div className="c-modal--link">
      <Link
        href={url}
        alt={alt || label}
        onClick={e => {
          e.preventDefault();
          onModalOpen(modalId);
        }}
      >
        <div className="c-modal__labelContainer">
          {icon}
          <span className="c-modal__label">{label}</span>
        </div>
      </Link>
      <Modal {...modal} modalId={modalId} isOpen={isOpen}>
        {children}
      </Modal>
    </div>
  );
};

ModalLink.propTypes = {
  modal: PropTypes.shape(Modal.propTypes).isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.elements]),
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  modalId: PropTypes.string,
  isOpen: PropTypes.bool,
  url: PropTypes.string,
  alt: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.element,
  ariaLabel: PropTypes.string,
};

ModalLink.defaultProps = {
  onModalOpen: () => {},
  onModalClose: () => {},
};

export default ModalLink;
